import { InMemoryCache } from "@apollo/client";
import introspectionResult from "../graphql/generated/fragment-matcher";

export const cache = new InMemoryCache({
  possibleTypes: introspectionResult.possibleTypes,
});
